import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

import { checkFieldErrorByType } from '@shared/lib/fields/checkFieldErrorByType/checkFieldErrorByType'
import { FieldBase } from '@shared/types/fields/fields'

type TypeHandleValid<T extends FieldBase> = (showError?: boolean) => T

export function useField<T extends FieldBase>(field: T): [T, Dispatch<SetStateAction<T>>, TypeHandleValid<T>] {
  const [state, setState] = useState<T>(field)
  const [valueHasChanged, setValueHasChanged] = useState(false)

  useEffect(() => {
    !valueHasChanged && setValueHasChanged(field.value !== state.value)
  }, [state.value])

  const timeoutID = useRef<NodeJS.Timeout>()
  useEffect(() => {
    if (state.autoValid) {
      clearTimeout(timeoutID.current)
      timeoutID.current = setTimeout(() => {
        const showError = valueHasChanged || field.value !== state.value
        handleValid(showError)
      }, 800)
    }
  }, [state.value, JSON.stringify(state.validations)])

  const handleValid: TypeHandleValid<T> = (showError = state.settings.showError) => {
    // Проверка на типы валидации в state.validations
    const getErrors = Object.keys(state.validations).map((type) => checkFieldErrorByType(type, state))

    const getFirstError = getErrors.find((item) => item !== false)

    setState((prev) => ({
      ...prev,
      error: showError ? getFirstError || '' : '',
      valid: !getFirstError,
    }))
    return {
      ...state,
      error: showError ? getFirstError || '' : '',
      valid: !getFirstError,
    }
  }

  return [state, setState, handleValid]
}
